export default __webpack_public_path__ + "static/media/unity.c6a4aca1.svg";